/**************************************************
 * Nombre:       Tarjeta_Contenido_Caps
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Contenido_Preguntas = ({item, index, click}) => {

    const visualizarRespuesta = (index) => {

        if (index) {
            let ind = parseInt(index)
            let res = item.opciones[ind - 1]
            return res
        }

    }

    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600, fontSize: 14}}>{item.pregunta}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography sx={{fontSize: 16}}>{visualizarRespuesta(item.correcta)}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Contenido_Preguntas